<template>
	<article class="small-12 flex residentsStatus sidebarWidget animated fadeIn">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Status by Resident</h3>
        </div>
        <div class="small-12 statusBreakdown">
            <div class="small-6 paid stat flex justify-center vertical-align border-bottom border-right">
                <div class="small-3 icon borderRadius8 flex vertical-align justify-center">
                    <i class="material-icons-outlined">credit_card</i>
                </div>
                <div class="small-8 data columns">
                    <p class="small-12">
                        Total Paid
                    </p>
                    <h6 class="small-12">
                        {{ totalPaid }}
                    </h6>
                </div>
            </div>
            <div class="small-6 columns open stat flex justify-center vertical-align border-bottom">
                <div class="small-3 icon borderRadius8 flex vertical-align justify-center">
                    <i class="material-icons-outlined">pending</i>
                </div>
                <div class="small-8 data columns">
                    <p class="small-12">
                        Total Open
                    </p>
                    <h6 class="small-12">
                        {{ totalOpen }}
                    </h6>
                </div>
            </div>
            <div class="small-6 late stat flex vertical-align border-right">
                <div class="small-3 icon borderRadius8 flex vertical-align justify-center">
                    <i class="material-icons-outlined">assignment_late</i>
                </div>
                <div class="small-8 data columns">
                    <p class="small-12">
                        Total Late
                    </p>
                    <h6 class="small-12">
                        {{ totalLate }}
                    </h6>
                </div>
            </div>
            <div class="small-6 draft stat flex vertical-align">
                <div class="small-3 icon borderRadius8 flex vertical-align justify-center">
                    <i class="material-icons-outlined">pending_actions</i>
                </div>
                <div class="small-8 data columns">
                    <p class="small-12">
                        Total Draft
                    </p>
                    <h6 class="small-12">
                        {{ totalDraft }}
                    </h6>
                </div>
            </div>
        </div>
        <div class="small-12 residentStatusListing">
            <ul class="small-12 float-left flex vertical-align" v-if="all_invoices.length > 0">
                <li class="small-6">
                    <p>Residents</p>
                </li>
                <li class="small-6 reportsMenu flex justify-right">
                    <a ref="residentsFilters" class="flex justify-center vertical-align borderRadius4" @click="showFilterDropdownMenu()">
                        <i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">filter_alt</i>
                        Filter
                    </a>
                    <div ref="residentsFiltersMenu" class="auto filterDropdownMenu animated fadeIn" v-show="show_filter_menu_dropdown">
                        <div class="small-12 filterWrap borderRadius4">
                            <div class="small-12 filterMenuLabel">
                                <p>Quick Filters</p>
                            </div>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('paid')">
                                <i class="material-icons-outlined">credit_card</i>
                                Paid
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('open')">
                                <i class="material-icons-outlined">pending</i>
                                Open
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('late')">
                                <i class="material-icons-outlined">assignment_late</i>
                                Late
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('draft')">
                                <i class="material-icons-outlined">pending_actions</i>
                                Draft
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('pending')">
                                <i class="material-icons-outlined">cached</i>
                                Pending
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('failed')">
                                <i class="material-icons-outlined">error_outline</i>
                                Failed
                            </a>
                            <a class="small-12 menuItem flex vertical-align" @click="filterBy('view_all')">
                                <i class="material-icons-outlined">list</i>
                                View All
                            </a>
                        </div>
                    </div>
                </li>
                <li class="small-12 flex vertical-align border-bottom animated fadeIn" v-for="(document, index) in queried_results" :key="index">
                    <router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: document.resident.id } }">
                        <div class="small-10 flex vertical-align">
                            <picture class="round flex justify-center vertical-align">
                                {{document.resident.attributes.contact_information.first_name | abbreviateName}} {{document.resident.attributes.contact_information.last_name | abbreviateName}}
                            </picture>
                            <div class="small-9 columns">
                                <p class="small-12 text-overflow">
                                    {{document.resident.attributes.contact_information.first_name }} {{document.resident.attributes.contact_information.last_name }}
                                </p>
                                <span class="badge borderRadius2 bgGreen" v-if="document.invoice.attributes.status == 'paid'">Paid</span>
                                <span class="badge borderRadius2 bgYellow" v-else-if="document.invoice.attributes.status == 'open'">Open</span>
                                <span class="badge borderRadius2 bgGrey" v-else-if="document.invoice.attributes.status == 'draft'">Draft</span>
                                <span class="badge borderRadius2 bgRed" v-else-if="document.invoice.attributes.status == 'late'">Late</span>
                                <small v-if="document.invoice.attributes.status == 'paid'"> on <i>{{ document.invoice.meta.updated_at | unixToDate }}</i></small>
                                <small v-else> as of <i>{{ document.invoice.meta.updated_at | unixToDate }}</i></small>
                            </div>
                        </div>
                        <div class="small-2">
                            <i class="material-icons border borderRadius4">keyboard_arrow_right</i>
                        </div>
                    </router-link>
                </li>
            </ul>
            <ul class="small-12 float-left flex" v-else>
                <li class="small-12">
                    <p>Residents</p>
                </li>
                <li class="small-12 columns flex justify-center empty borderRadius8 bgOffsetGrey">
                    <p class="small-12 large-10 columns text-center">No invoices have been assigned at this time.</p>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
    import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentsStatus',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
            AbbreviateNameFilter,
            DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			late_invoices: {
                type: Array,
                default: () => []
            },
            draft_invoices: {
                type: Array,
                default: () => []
            },
            paid_invoices: {
                type: Array,
                default: () => []
            },
            open_invoices: {
                type: Array,
                default: () => []
            },
            all_invoices: {
                type: Array,
                default: () => []
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			show_filter_menu_dropdown: false,
            queried_results: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			all_invoices: {

				immediate: true, // Load on created
				handler(all_invoices) {

                    /*
					**  Set the results prop
					**  @prop: @here
					*/

					this.queried_results = this.all_invoices;

				}

			}

		},

		/*
        ** Do this first
        */

        created() {

        	window.addEventListener('click', this.closeFilterMenu);

        },

		beforeDestroy() {

			window.removeEventListener('click', this.closeFilterMenu);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			showFilterDropdownMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (!this.show_filter_menu_dropdown) {

						this.show_filter_menu_dropdown = true;

					} else {

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Show the Filter Dropdown Menu',
						errorType: 'Application',
						section: 'Residents Status',
						uid: 'vzImrU8LEs0uYjzqYZOX',
						error: e
					});

				}

			},

            closeFilterMenu(evt) {

				try {

					let containsElement = this.$el.contains(evt.target),
						parentElement = evt.target.parentElement;

					/*
					**  If menu wasn't clicked
					*/

					if (evt.target !== this.$refs['residentsFiltersMenu'] && evt.target !== this.$refs['residentsFilters'] && parentElement !== this.$refs['residentsFilters']) {

						/*
						**  Set the prop
						**  @prop: @here
						*/

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to close the residents filter menu',
						errorType: 'Application',
						section: 'Residents Status',
						uid: 'HaNEwgy1vdvYcF5VtVAG',
						error: e
					});

				}

		    },

            filterBy: function(value) {

				try {

                    /*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the results
					**  @prop: @here
					*/

					if (this.all_invoices.length > 0) {

                        /*
                        **  If a filter is applied
                        */

                        if (value !== 'view_all') {

                            return this.all_invoices.filter((document)=>{

                                /*
                                **  If paid
                                */

                                if (value == 'paid' && document.invoice.attributes.status == 'paid') return this.queried_results.push(document);

                                /*
                                **  If late
                                */

                                if (value == 'late' && document.invoice.attributes.status == 'late') return this.queried_results.push(document);

                                /*
                                **  If pending
                                */

                                if (value == 'pending' && document.invoice.attributes.status == 'pending') return this.queried_results.push(document);

                                /*
                                **  If open
                                */

                                if (value == 'open' && document.invoice.attributes.status == 'open') return this.queried_results.push(document);

                                /*
                                **  If failed
                                */

                                if (value == 'failed' && document.invoice.attributes.status == 'failed') return this.queried_results.push(document);

                                /*
                                **  If draft
                                */

                                if (value == 'draft' && document.invoice.attributes.status == 'draft') return this.queried_results.push(document);

						    });

                        } else {

                            /*
                            **  If view all is selected
                            */

                            return this.queried_results = this.all_invoices;

                        }

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.all_invoices;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to apply a status filter when filtering residents.',
						errorType: 'Application',
						section: 'Residents Status',
						uid: 'ZVj2VY20IcMMi10NRH0W',
						error: e
					});

				}

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

            totalLate: function() {

				return this.late_invoices.length;

			},

            totalPaid: function() {

				return this.paid_invoices.length;

			},

            totalOpen: function() {

				return this.open_invoices.length;

			},

            totalDraft: function() {

				return this.draft_invoices.length;

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>